module.exports = __webpack_public_path__ + "resources/img/sp_checkbox_v2.af9ff348a7d762d04e71b71aa0e098f3.png";